import { render, staticRenderFns } from "./TicketsMail.vue?vue&type=template&id=10c7d81d&scoped=true"
import script from "./TicketsMail.vue?vue&type=script&lang=js"
export * from "./TicketsMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c7d81d",
  null
  
)

export default component.exports